import { merge, $ } from "glamor";
import theme from "styles/theme";

const TAB_HEADER_CONTAINER = 48;
export const styles = {
    modalContainer: {
        width: "95%",
        height: "95%",
        maxWidth: "none",
        padding: 0,
    },
    content: merge(
        $(" .description", {
            fontSize: "14px",
            color: theme.palette.darkGrey,
            margin: "20px 0",
        }),
        $(" .uploaderWithTabs", {
            minHeight: "400px",
        })
    ),
    bodyContainer: {
        padding: 0,
    },
    tabs: merge(
        {
            marginTop: "10px",
        },
        $(" .tab", {
            backgroundColor: `${theme.palette.white} !important`,
            color: `${theme.palette.darkGrey} !important`,
            borderBottom: "1px solid #BDBDBD !important",
            padding: "0 30px !important",
            textTransform: "none !important",
        }),
        $(" .tab.selected", {
            fontWeight: "700 !important",
            color: `${theme.palette.darkerGrey} !important`,
        }),
        $(" .tabpanel", {
            height: `calc(100% - ${TAB_HEADER_CONTAINER}px)`,
            overflowY: "auto",
            overflowX: "hidden",
            padding: "0 24px 16px",
        })
    ),
    modalActions: merge(
        $(".actions", {
            alignItems: "center",
            display: "flex",
            justifyContent: "space-between",
            padding: "20px 20px 0 20px !important",
        }),
        $(".actions svg", {
            cursor: "pointer",
            fill: `${theme.palette.darkGrey} !important`,
            width: "16px !important",
            height: "16px !important",
        }),
        $(" .modalTitle", {
            fontSize: "20px",
            margin: "0",
        }),
        $(" .titleRight", {
            textAlign: "right",
        }),
        $(" .isSavingText", {
            display: "inline-block",
            fontSize: "14px",
            marginRight: "20px",
            verticalAlign: "text-bottom",
        })
    ),
};
